import React, { PureComponent } from 'react';
import { dAPI } from 'appSrc/api';
import { DLModal } from 'appSrc/components/Shards';
import LoadingOverlay from 'appSrc/components/Shards/Loading/Overlay';
import { PrimaryButton, DLTextField } from 'appSrc/components/UI';
import style from './styles/style.module.css';


class UpdatePasswordModal extends PureComponent {
    state = { working: false, password: '' }

    changeHandler = ( evt, { value } ) => {
        this.setState( { password: value } );
    }
    submitHandler = () => {
        this.setState( { working: true } );

        dAPI.patch( `/auth/users/${ this.props.id }/password`, { password: this.state.password } )
        .then( () => {
            this.setState( { working: false, password: '' } );
            this.props.closeHandler();
        } );
    }



    render() {
        const { working, password } = this.state;

        return (
            <DLModal title='Update Password' className={ style.passModal } visible={ this.props.visible }
            closeHandler={ this.props.closeHandler }>
                <div>
                    <DLTextField value={ password }
                    onChange={ this.changeHandler } />

                    <PrimaryButton label='Submit' onClick={ this.submitHandler }
                    fullWidth />
                </div>
                { working &&
                    <LoadingOverlay />
                }
            </DLModal>
        );
    }
}
UpdatePasswordModal.defaultProps = {
    onSubmit: () => {},
};

export default UpdatePasswordModal;
